import React from 'react';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import EventOutlined from '@mui/icons-material/EventOutlined';
import MedicalServicesOutlined from '@mui/icons-material/MedicalServicesOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import DrawOutlined from '@mui/icons-material/DrawOutlined';
import VaccinesOutlined from '@mui/icons-material/VaccinesOutlined';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
export default function TemplatePurposeIcon({name}:{name:string}){
 const Icon=/informe|resultado/.test(name)?DescriptionOutlined:/cirugia|cirugía/.test(name)?MedicalServicesOutlined:/factura|ticket/.test(name)?ReceiptLongOutlined:/pedido|recoger/.test(name)?Inventory2Outlined:/firma/.test(name)?DrawOutlined:/vacun|desparasit/.test(name)?VaccinesOutlined:/cita|reserva/.test(name)?EventOutlined:ChatBubbleOutline;
 return <Icon aria-hidden="true" style={{fontSize:20,color:'#52766d',flexShrink:0,verticalAlign:'middle',marginRight:10}}/>;
}
